import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './components/disconnectModal';


// import './styles.css';

const cogoToast = (text, channelNames) => {
    let rootContainer = document.getElementById('ct-container');
    if (!rootContainer) {
        rootContainer = document.createElement('div');
        rootContainer.id = 'ct-container';
        document.body.appendChild(rootContainer)


    }

    ReactDOM.render(
        <Modal
            tag='Modal_1'
            title={text === "disconnected" ? 'عدم برقراری ارتباط' : (text == "expiredAccount" || text == "OneDayToExpire" ? "اتمام شارژ کیف پول" : (text == 'showTelegramModal' ? "اتصال به تلگرام" : "‌به‌روزرسانی‌ قیمت‌ها"))}
            value={true}
            parentClose={() => hide()}
            type={text}
            props={channelNames}
        >
        </Modal>, rootContainer);

    const hide = () => {
        ReactDOM.render(<Modal
            tag='Modal_1'
            title='عنوان'
            value={false}
            type={text}
        />, rootContainer);
    };


};


export { Modal };

export default cogoToast;
